import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { settingsService } from "@/services/settingsService";
import { adminService } from "@/services/adminService";

export function usePublicSettings() {
  return useQuery({
    queryKey: ["settings", "public"],
    queryFn: settingsService.getPublic,
    staleTime: 5 * 60 * 1000,
  });
}

export function useAdminSettings() {
  return useQuery({ queryKey: ["admin", "settings"], queryFn: adminService.getSettings });
}

export function useUpdateSettings(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: adminService.updateSettings,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["admin", "settings"] });
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useUpdateLanding(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: settingsService.updateLanding,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useBranding() {
  return useQuery({ queryKey: ["admin", "branding"], queryFn: settingsService.getBranding });
}

export function useBrandingMutation(mutationFn, options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["admin", "branding"] });
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useDojoAdmin() {
  return useQuery({ queryKey: ["admin", "dojo"], queryFn: settingsService.getDojo });
}
export function useDojoMutation(mutationFn, options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["admin", "dojo"] });
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useGuideAdmin() {
  return useQuery({ queryKey: ["admin", "guide"], queryFn: settingsService.getGuide });
}
export function useGuideMutation(mutationFn, options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["admin", "guide"] });
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}


export function useExpertMeAiAdmin() {
  return useQuery({ queryKey: ["admin", "expertmeai"], queryFn: settingsService.getExpertMeAi });
}

export function useUpdateExpertMeAi(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: settingsService.updateExpertMeAi,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["admin", "expertmeai"] });
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useAdminPromos() {
  return useQuery({ queryKey: ["admin", "promos"], queryFn: settingsService.getPromos });
}

export function useAdminPlugins() {
  return useQuery({ queryKey: ["admin", "plugins"], queryFn: adminService.getPlugins });
}

export function useTogglePlugin(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: adminService.togglePlugin,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["admin", "plugins"] });
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}

export function useUpdatePromos(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: settingsService.updatePromos,
    ...options,
    onSuccess: (...args) => {
      qc.invalidateQueries({ queryKey: ["admin", "promos"] });
      qc.invalidateQueries({ queryKey: ["settings", "public"] });
      options.onSuccess?.(...args);
    },
  });
}
